// extracted by mini-css-extract-plugin
module.exports = {"shareLink":"ArticleShare-module__ZkfEkq__shareLink","snackbar":"ArticleShare-module__ZkfEkq__snackbar","shareContainer":"ArticleShare-module__ZkfEkq__shareContainer"};